import { render, staticRenderFns } from "./GeneralSettingsAccordion.vue?vue&type=template&id=c49d956e&scoped=true&"
import script from "./GeneralSettingsAccordion.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingsAccordion.vue?vue&type=style&index=0&id=c49d956e&scoped=true&lang=scss&"
import style1 from "./GeneralSettingsAccordion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49d956e",
  null
  
)

export default component.exports